import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { EmailService } from 'src/app/services/email.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  public submitted = false;
  public succeed = false;
  public email: string;

  constructor(private _emailService: EmailService) { }

  public onSubmit() {
    this.submitted = true;
    this._emailService.requestResetPassword(this.email).subscribe(() => {
      this.succeed = true;
    }, () => {
      this.submitted = false;
    });
  }
}
